var _defs, _rect, _rect2, _circle, _rect3, _text, _text2, _circle2, _circle3, _circle4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _circle5, _text3, _line, _text4, _text5, _ellipse8, _ellipse9, _rect4, _text6, _text7, _rect5, _text8, _text9, _line2, _rect6, _text0, _text1, _text10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinFlip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 600",
    width: 440,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf-bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#120d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#1a1200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0d0900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cf-coin",
    cx: "38%",
    cy: "32%",
    r: "62%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff8c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#ffe266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#ffc824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8a5c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cf-rim",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "82%",
    stopColor: "#c88000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6b4400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf-title",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffc84c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffe896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf-heads",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2a1f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a1300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf-tails",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#001028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000c1c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cf-ambient",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(255,200,76,0.18)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255,200,76,0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cf-dots",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 0.7,
    fill: "rgba(255,200,76,0.06)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "url(#cf-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "url(#cf-dots)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 270,
    r: 200,
    fill: "url(#cf-ambient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 440,
    height: 3,
    fill: "url(#cf-title)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 54,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 28,
    fontWeight: 900,
    fill: "url(#cf-title)",
    letterSpacing: 4
  }, "COIN FLIP")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 76,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fontWeight: 500,
    fill: "rgba(255,255,255,0.35)",
    letterSpacing: 3
  }, "HEADS OR TAILS?")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 110,
    r: 5,
    fill: "rgba(255,200,76,0.5)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 94,
    r: 3.5,
    fill: "rgba(255,200,76,0.3)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 82,
    r: 2,
    fill: "rgba(255,200,76,0.15)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220,
    cy: 318,
    rx: 108,
    ry: 14,
    fill: "rgba(0,0,0,0.5)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220,
    cy: 300,
    rx: 112,
    ry: 112,
    fill: "#7a4e00"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220,
    cy: 290,
    rx: 112,
    ry: 112,
    fill: "url(#cf-rim)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220,
    cy: 282,
    rx: 112,
    ry: 112,
    fill: "url(#cf-coin)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220,
    cy: 282,
    rx: 112,
    ry: 112,
    fill: "none",
    stroke: "rgba(255,230,100,0.4)",
    strokeWidth: 3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220,
    cy: 282,
    rx: 102,
    ry: 102,
    fill: "none",
    stroke: "rgba(0,0,0,0.18)",
    strokeWidth: 1.5
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220,
    cy: 282,
    rx: 90,
    ry: 90,
    fill: "none",
    stroke: "rgba(255,230,100,0.08)",
    strokeWidth: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 282,
    r: 74,
    fill: "rgba(0,0,0,0.12)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 264,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 34,
    fontWeight: 900,
    fill: "rgba(255,255,255,0.85)",
    letterSpacing: 2
  }, "NGB")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 168,
    y1: 274,
    x2: 272,
    y2: 274,
    stroke: "rgba(255,255,255,0.3)",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 292,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "rgba(255,255,255,0.55)",
    letterSpacing: 3
  }, "NEXTGEN")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 308,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "rgba(255,255,255,0.4)",
    letterSpacing: 2
  }, "BETS")), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 194,
    cy: 250,
    rx: 28,
    ry: 18,
    fill: "rgba(255,255,255,0.22)",
    transform: "rotate(-30,194,250)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220,
    cy: 282,
    rx: 118,
    ry: 118,
    fill: "none",
    stroke: "rgba(255,200,76,0.15)",
    strokeWidth: 2,
    strokeDasharray: "8,12"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 220 282",
    to: "360 220 282",
    dur: "8s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 428,
    width: 174,
    height: 52,
    rx: 10,
    fill: "url(#cf-heads)",
    stroke: "rgba(255,200,76,0.35)",
    strokeWidth: 1.5
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 119,
    y: 449,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 10,
    fill: "rgba(255,255,255,0.4)",
    letterSpacing: 2
  }, "HEADS")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 119,
    y: 468,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 16,
    fontWeight: 800,
    fill: "#ffc84c"
  }, "50.00%")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 428,
    width: 174,
    height: 52,
    rx: 10,
    fill: "url(#cf-tails)",
    stroke: "rgba(82,111,255,0.35)",
    strokeWidth: 1.5
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 321,
    y: 449,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 10,
    fill: "rgba(255,255,255,0.4)",
    letterSpacing: 2
  }, "TAILS")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 321,
    y: 468,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 16,
    fontWeight: 800,
    fill: "#526fff"
  }, "50.00%")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 494,
    x2: 408,
    y2: 494,
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 504,
    width: 376,
    height: 52,
    rx: 10,
    fill: "rgba(255,200,76,0.05)",
    stroke: "rgba(255,200,76,0.12)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.12;0.5;0.12",
    dur: "2.2s",
    repeatCount: "indefinite"
  }))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 524,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fill: "rgba(255,255,255,0.38)",
    letterSpacing: 1
  }, "PAYOUT ON WIN")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 543,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 17,
    fontWeight: 800,
    fill: "#ffc84c"
  }, "2.00\xD7")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 578,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fill: "rgba(255,255,255,0.22)",
    letterSpacing: 2
  }, "NEXTGEN ORIGINALS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinFlip);
export default __webpack_public_path__ + "static/media/coin-flip.c65cd76cca0b63dbe55b9b522d66731e.svg";
export { ForwardRef as ReactComponent };